<template>
  <button class="sidebar-minimizer" type="button" @click="sidebarMinimize()"></button>
</template>
<script>

export default {
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize () {
      document.body.classList.toggle('sidebar-minimized')
      document.body.classList.toggle('brand-minimized')
    }
  }
}
</script>
